module.exports = __webpack_public_path__ + "img/clipit.591b6178.png";